import finanzaemter from "finanzamt/data/finanzaemter.json";

type Finanzamt = {
  buFaNr: string;
  name: string;
};

const STATE_PREFIXES: Record<string, string[]> = {
  "Baden-Württemberg": ["28"],
  Bayern: ["91", "92"],
  Berlin: ["11"],
  Brandenburg: ["30"],
  Bremen: ["24"],
  Hamburg: ["22"],
  Hessen: ["26"],
  "Mecklenburg-Vorpommern": ["40"],
  Niedersachsen: ["23"],
  "Nordrhein-Westfalen": ["51", "52", "53"],
  "Rheinland-Pfalz": ["27"],
  Saarland: ["10"],
  Sachsen: ["32"],
  "Sachsen-Anhalt": ["31"],
  "Schleswig-Holstein": ["21"],
  Thüringen: ["41"],
};

const taxOffices = finanzaemter as Finanzamt[];

export const federalStateOptions = Object.keys(STATE_PREFIXES).map((state) => ({
  label: state,
  value: state,
}));

export const getTaxOfficeOptions = (state?: string) => {
  const prefixes = state ? STATE_PREFIXES[state] : undefined;
  if (!prefixes) return [];

  return taxOffices
    .filter(({ buFaNr }) =>
      prefixes.some((prefix) => buFaNr.startsWith(prefix))
    )
    .map(({ buFaNr, name }) => ({
      label: `${name} (${buFaNr})`,
      name,
      value: buFaNr,
    }));
};

export const getTaxOfficeName = (
  state?: string,
  taxOfficeCode?: string
): string | undefined =>
  getTaxOfficeOptions(state).find(({ value }) => value === taxOfficeCode)?.name;
